import React from 'react';
import withRouter from '../../Components/Common/withRouter';

const Home = ({ children }) => {
    return (
        <React.Fragment>
            <div className="home-page-wrapper pt-5">
                <div className="home-one-bg-position home-one-bg" id="home-particles">

                   

                </div>

                {/* pass the children */}
                {children}

                {/* <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">&copy; {new Date().getFullYear()} SeedNations. Crafted with <i className="mdi mdi-heart text-danger"></i> by DATAPROX</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> */}
            </div>
        </React.Fragment>
    );
};

export default withRouter(Home);